<template>
  <section class="page-banner">
    <div class="page-banner__media" aria-hidden="true">
      <img class="page-banner__img" :src="bannerImage" alt="" decoding="async" fetchpriority="high" />
    </div>
    <div class="page-banner__veil" aria-hidden="true"></div>

    <div class="container page-banner__inner">
      <h1 class="page-banner__title">{{ title }}</h1>
      <p v-if="lead" class="page-banner__lead">{{ lead }}</p>
      <nav class="page-banner__crumbs" :aria-label="$t('header.breadcrumb')">
        <ol>
          <li>
            <router-link to="/">{{ $t('header.home.title') }}</router-link>
          </li>
          <li v-if="parentTo">
            <router-link :to="parentTo">{{ parentLabel }}</router-link>
          </li>
          <li aria-current="page">{{ current }}</li>
        </ol>
      </nav>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageBanner',
  computed: {
    bannerImage() {
      return this.$store.state.userLogin && this.lightImage ? this.lightImage : this.image
    }
  },
  props: {
    lightImage: {
      type: String,
      default: ''
    },
    parentTo: {
      type: String,
      default: ''
    },
    parentLabel: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    lead: {
      type: String,
      default: ''
    },
    // Breadcrumb label for the current page
    current: {
      type: String,
      required: true
    }
  }
}
</script>
